<div id="comicViewPane" style="min-height: 300px; min-width: 300px;">
    <mat-card>
        <mat-card-title>	
            <h1>Chapter {{chapterNumber}} : Page {{imageNumber}}</h1>
        </mat-card-title>
        <mat-card-content></mat-card-content>
        <img mat-card-image src="{{ imageLink }}" alt="Page_1">
        <mat-divider [inset]="true"></mat-divider>
    </mat-card>
</div>